<template>
  <div class="ms-5">
    <div class="dropdown">
      <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="filterDropdown" data-bs-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
        <i class="fas fa-filter"></i> filter
      </button>
      <div class="dropdown-menu filter-options-dropdown" aria-labelledby="filterDropdown">

        <div v-if="!view.filters || view.filters.length === 0" class="container">
          You do not have any filters for this view.
        </div>

        <div v-else class="container">
          <div class="row pt-1" v-for="(filter, index) in view.filters">

            <filter-editor :table="table" :filter="filter" :view="view"
                           :key="view.id + table.id + 'filter' + index"></filter-editor>

          </div>
        </div>

        <div class="container mt-2">
          <a href="javascript:void(0)" class="btn btn-sm btn-light" @click.stop="onAddFilterClick">add filter</a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import FilterEditor from "./FilterEditor.vue"

  export default {
    components: {FilterEditor},
    name: 'FilterDropdown',
    props: ['view', 'table'],
    methods: {
      onAddFilterClick() {
        let filter = {
          id: null,
          field_id: null,
          filter_operator: '',
          filter_value: ''
        }

        this.view.filters.push(filter)
      }
    }
  }
</script>
